// extracted by mini-css-extract-plugin
export default {"mainContainer":"Uploader_mainContainer__je7FA","uploadButton":"Uploader_uploadButton__+ZmOS","uploadIcon":"Uploader_uploadIcon__mMGkp","uploadText":"Uploader_uploadText__xWaq8"};